// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tiUf","col":"styles_col__1uLlY","actions":"styles_actions__e0oDJ","conflict":"styles_conflict__1ngJa"};